module.exports = __webpack_public_path__ + "img/psychological_renbao_02.3379c455.jpg";